<template>
  <div class="col-12">
    <div class="tile d-flex flex-row align-items-center mt-0 p-2 py-3 rounded">
      <div
        v-if="loadingplayer == 100"
        class="col-2 col-sm-2 col-xs-2 col-lg-1 col-xl-1 text-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="50px"
          height="50px"
          v-if="playing"
          viewBox="0 0 512 512"
          @click="fnPause"
        >
          <path
            fill="#fff"
            d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM224 191.1v128C224 337.7 209.7 352 192 352S160 337.7 160 320V191.1C160 174.3 174.3 160 191.1 160S224 174.3 224 191.1zM352 191.1v128C352 337.7 337.7 352 320 352S288 337.7 288 320V191.1C288 174.3 302.3 160 319.1 160S352 174.3 352 191.1z"
          />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          v-else
          viewBox="0 0 512 512"
          width="50px"
          height="50px"
          @click="fnPlay"
        >
          <path
            fill="#fff"
            d="M512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM176 168V344C176 352.7 180.7 360.7 188.3 364.9C195.8 369.2 205.1 369 212.5 364.5L356.5 276.5C363.6 272.1 368 264.4 368 256C368 247.6 363.6 239.9 356.5 235.5L212.5 147.5C205.1 142.1 195.8 142.8 188.3 147.1C180.7 151.3 176 159.3 176 168V168z"
          />
        </svg>
      </div>
      <div v-else>{{ loadingplayer }} %</div>
      <div class="col-4 col-sm-4 col-xs-4 col-lg-6 col-xl-6 ml-2">
        <wavesurfer :src="url" :options="options" ref="uplayer"></wavesurfer>
      </div>
      <!-- <div class="
          col-2
          d-text d-sm-none d-xs-none d-md-none d-none d-lg-block d-xl-block
        "></div> -->
      <div v-if="approved == 0" class="col-4 px-2">
        <div
          v-if="disableRevBtn"
          class="w-100 col-12 d-flex justify-content-around"
        >
          <div class="s-text">
            <Button class="btn-revise" @click="openModal">Add Note</Button>
          </div>
          <div class="s-text">
            <Button
              :disabled="sendingDisabled"
              class="btn-revise"
              @click="sendRemix"
              >Send</Button
            >
          </div>
        </div>
        <div class="w-100" v-else>
          <Button class="btn-revise">Add Credits</Button>
        </div>
      </div>
      <div v-else></div>
      <div
        class="col-2 col-sm-2 col-xs-2 col-lg-1 col-xl-1 text-right d-flex justify-content-end"
      >
        <a :href="url" class="d-flex justify-content-center align-items-center">
          <img
            class="d-img mx-1"
            src="../assets/download.png"
            alt=""
            height="30px"
            width="30px"
        /></a>
      </div>
    </div>
    <div
      v-if="revisionText.length > 0"
      v-for="revisions in revisionText"
      class="revText d-flex justify-content-between"
    >
      <p>{{ revisions.text }}</p>
      <p>{{ revisions.timestamp }}</p>
    </div>
    <div v-else></div>
    <b-modal ref="remixModal" centered>
      <div class="d-flex flex-column justify-content-center align-items-start">
        <div class="w-100 d-flex justify-content-between">
          <label class="l-modal" for="">Enter Your Note:</label>
          <p class="l-modal">{{ currentplaying }}</p>
        </div>

        <div class="w-100">
          <textarea
            class="r-modal w-100"
            name="text_revision"
            id="t-revision"
            cols="40"
            rows="4"
            maxlength="1000"
            placeholder="I need to ..."
            v-model="remixText"
          ></textarea>
        </div>
      </div>
      <template slot="modal-footer">
        <div class="mt-4 p-0 h-0">
          <button @click="closeModal" class="btn-revision">Add</button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
// import WaveSurferVue from "wavesurfer.js-vue";
import { async } from "q";
import Cursor from "wavesurfer.js/dist/plugin/wavesurfer.cursor";
import Markers from "wavesurfer.js/dist/plugin/wavesurfer.markers";
import { postNewRemix } from "../services/remix.service";
export default {
  components: {
    // WaveSurferVue,
  },
  data() {
    return {
      sendingDisabled: false,
      loadingplayer: 0,
      currentplaying: 0,
      currentregions: 0,
      currentSeconds: 0,
      revisionText: [],
      markersTime: [],
      selectedMarkerIndex: 0,
      currentRevCount: 0,
      playing: 0,
      options: {
        mediaControls: true,
        normalize: true,
        barWidth: 3,
        barGap: 1,
        plugins: [Cursor.create(), Markers.create()],
        barHeight: 1,
        height: 50,
        cursorColor: "#2BFED1",
        progressColor: "#2BFED1"
      },
      remixText: "",
      notes: 1
    };
  },
  props: {
    name: String,
    url: String,
    id: String,
    approved: Number
  },
  computed: {
    player() {
      return this.$refs.uplayer.waveSurfer;
    },
    disableRevBtn() {
      return this.$store.state.apiEvents.remainingRevisions > 0 ? true : false;
    }
  },
  mounted() {
    this.player.on("ready", () => {});

    this.player.on("loading", (val, evt) => {
      this.loadingplayer = val;
    });
    this.player.on("region-created", () => {
      this.currentregions++;
    });
    this.player.on("marker-click", marker => {
      this.selectedMarkerIndex = this.markersTime.indexOf(marker.time);
    });
  },
  methods: {
    fnPlay() {
      this.playing = 1;
      this.player.play();
    },
    fnPause() {
      this.playing = 0;
      this.player.pause();
    },
    openModal() {
      var currentSec = this.player.getCurrentTime();
      this.currentSeconds = currentSec;
      this.currentplaying = this.secondsToTime(currentSec);

      this.$refs.remixModal.show();
    },
    secondsToTime(e) {
      const h = Math.floor(e / 3600)
          .toString()
          .padStart(2, "0"),
        m = Math.floor((e % 3600) / 60)
          .toString()
          .padStart(2, "0"),
        s = Math.floor(e % 60)
          .toString()
          .padStart(2, "0");
      return h + ":" + m + ":" + s;
    },
    closeModal() {
      let markerOpt = {
        time: this.currentSeconds,
        label: "R",
        color: "#ebb734"
      };
      this.player.addMarker(markerOpt);
      this.markersTime.push(this.currentSeconds);
      this.revisionText.push({
        text: this.remixText,
        timestamp: this.currentplaying
      });
      this.remixText = "";
      this.$refs.remixModal.hide();
    },
    sendRemix() {
      this.sendingDisabled = true;
      this.$store
        .dispatch("trackData/setUpdateRemixData", {
          data: this.revisionText,
          type: ""
        })
        .then(e => {
          this.$swal.fire({
            title: "Sending Revisions!",
            text: "processing in progress...",
            imageUrl: "https://api.getmxd.com/assets/spinner.gif",
            imageHeight: 200,
            imageWidth: 200,
            imageAlt: "loading...",
            animation: false,
            buttons: false,
            showConfirmButton: false,
            closeOnClickOutside: false,
            didOpen: () => {},
            willClose: () => {}
          });

          this.$store.dispatch("apiEvents/useRevisionCredit").then(() => {
            postNewRemix(
              this.id,
              this.revisionText,
              localStorage.getItem("userId")
            ).then(() => {
              this.$store.dispatch("trackData/setTrackStatus", "Revising");
            });
            // this.$store
            //   .dispatch("trackData/sendRemixData", { trackid: this.id })
            //   .then(() => {
            //     this.$store.dispatch("trackData/setTrackStatus", "Revising");
            //   });
          });
        })
        .then(() => {
          console.log("sent notes");
          this.$swal.close();
          this.$refs.remixModal.hide();
          window.location.reload();
        })
        .catch(() => {
          this.sendingDisabled = false;
        });
    },
    addNote() {
      if (this.notes <= 2) {
        this.notes += 1;
      } else {
        return;
      }
    },
    removeNote() {
      if (this.notes > 0) {
        this.notes -= 1;
      } else {
        return;
      }
    }
  }
};
</script>

<style scoped>
.color-select label {
  position: relative;
}

.revText {
  margin: 5px 0px 0px 0px;
  background-color: #2c2d2e;
  border-radius: 6px;
}

.revText p {
  padding: 10px;
  margin: 0;
}

.btn-revise {
  padding: 6px 12px !important;
  background-color: transparent;
  color: #2bfed1;
  border-radius: 20px;
  border: 2px solid #2bfed1;
}

@media only screen and (max-width: 600px) {
  .btn-revise {
    font-size: 8px;
    padding: 6px 12px !important;
    background-color: transparent;
    color: #2bfed1;
    margin: 6px;
    border-radius: 20px;
    border: 2px solid #2bfed1;
  }
}

.color-select .active {
  border: #313131;
}

.color-circle {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.red {
  background-color: red;
}

.yellow {
  background-color: yellow;
}

.green {
  background-color: green;
}

.orange {
  background-color: orange;
}

.grey {
  background-color: grey;
}

.btn-revision {
  padding: 6px 12px !important;
  background-color: #585858;
  color: #ffffff;
  border-radius: 20px;
  border: 0px solid #ebebeb;
}

.btn-subt {
  background: transparent;
  border: none;
}

.r-modal {
  padding: 5px;
  color: #797979;
  border: 1px solid #ebebeb;
  background-color: #f7f7f7;
}

.l-modal {
  color: #313131;
}
</style>
